<mat-card>
  @if (canImportGym) {
    <mat-card-content>
      <p>
        Fill the slug values and click the button to import the gym from if it
        exists.
      </p>
      <form [formGroup]="importForm">
        <mat-form-field class="w-100">
          <mat-label>Slug</mat-label>
          <input
            matInput
            placeholder="Slug"
            name="slug"
            id="slug"
            formControlName="slug"
            required
            pattern="^[a-z0-9-]+$" />
          @if (slug?.errors?.['required']) {
            <mat-error>
              Value is required
            </mat-error>
          }
          @if (slug?.errors?.['pattern']) {
            <mat-error>
              Only small letters, numbers and hyphens are allowed
            </mat-error>
          }
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          (click)="importGym()"
          [disabled]="!importForm.valid"
          class="button">
          <mat-icon>import_export</mat-icon>
          Import Gym: {{ gymId }}
        </button>
      </form>
    </mat-card-content>
  }
  @if (!canImportGym) {
    <mat-card-content>
      <gymfinder-alert variant="warning" class="alert-margin-top">
        <span>
          <strong>Warning:</strong> The provided Gym Id is not valid for
          importing.
        </span>
      </gymfinder-alert>
    </mat-card-content>
  }
</mat-card>
